import * as types from '../types'

/**
 * 标准列表
 * list: 标准列表
 * detail: 标准详情
 * @type {Object}
 */
const state = {
    navs: [
        {
            id: 1,
            name: '无农药',
            thumb: 'standards/1.png'
        },
        {
            id: 2,
            name: '野生',
            thumb: 'standards/2.png'
        },
        {
            id: 3,
            name: '原生态',
            thumb: 'standards/3.png'
        },
        {
            id: 4,
            name: '合理用药',
            thumb: 'standards/4.png'
        }
    ],
    list: [],
    detail: {
        content: []
    }
}

const getters = {

}

const mutations = {
    [types.INIT_STANDARD_LIST] (state, list) {
        state.list = list
    },

    [types.AJAX_UPDATE_STANDARD_LIST] (state, list) {
        state.list = state.list.concat(list)
    },

    [types.INIT_STANDARD_DETAIL] (state, params) {
        state.detail = params
    }
}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/standards.js